import React, { useState } from 'react';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Loader from '../components/loader';

const MainLayout = ({ children, loading = false }) => {
  const [sidebarVisible, setSidebarVisible] = useState(false);

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  return (
    <div className={sidebarVisible ? 'toggle-sidebar' : ''}>

      {loading && (
        <div
          style={{ zIndex: 9999 }}
          className="absolute top-0 left-0"
        >
          <Loader />
        </div>
      )}

      <Header toggleSidebar={toggleSidebar} />
      <Sidebar />

      <main id="main" className="main duo-main-bg">
        {children}
      </main>
    </div>
  );
};

export default MainLayout;